import Vue from 'vue'
import Router from 'vue-router'
import Main from './modules/Layout/index.vue'
import loginRoutes from '@/modules/Authentication/router'
import MasjidAd from '@/modules/masjidAd/router.js'
import MasjidImage from '@/modules/MasjidImage/router.js'
import signUpRoutes from '@/modules/SignUp/router'
import newOrganizationRoutes from '@/modules/NewOrganization/router'
import homeRoutes from '@/modules/Home/router'
import locationRoutes from '@/modules/Location/router'
import contactRoutes from '@/modules/Contact/router'
import globalRoutes from '@/modules/Global/router'
import leadRoutes from '@/modules/Leads/router'
import commentRoutes from '@/modules/Comment/router'
import feedbackRoutes from '@/modules/Feedback/router'
import ticketRoutes from '@/modules/Tickets/router'
import oranizationRoutes from '@/modules/Organization/router'
import promotionRoutes from '@/modules/Promotion/router'
import invoiceRoutes from '@/modules/Invoice/router'
import reconcileRoutes from '@/modules/Reconcile/Setting/router'
import walletRoutes from '@/modules/Wallet/router'
import userRoutes from '@/modules/User/router'
import settingRoutes from '@/modules/Setting/router'
import languageRoutes from '@/modules/Language/router'
import adImageRoutes from '@/modules/AdImage/router'
import activityRoutes from '@/modules/Activity/router'
import inventoryRoutes from '@/modules/Inventory/router'
import numberSearch from '@/modules/NumberSearch/router'
import taskRoutes from '@/modules/Tasks/router'
import bonventaRoutes from '@/modules/Bonventa/router.js'
import marketingRoutes from '@/modules/Marketing/router.js'

Vue.use(Router);

let mainRoutes = []
mainRoutes = mainRoutes.concat(homeRoutes)
mainRoutes = mainRoutes.concat(userRoutes)
mainRoutes = mainRoutes.concat(leadRoutes)
mainRoutes = mainRoutes.concat(commentRoutes)
mainRoutes = mainRoutes.concat(locationRoutes)
mainRoutes = mainRoutes.concat(contactRoutes)
mainRoutes = mainRoutes.concat(feedbackRoutes)
mainRoutes = mainRoutes.concat(ticketRoutes)
mainRoutes = mainRoutes.concat(oranizationRoutes)
mainRoutes = mainRoutes.concat(promotionRoutes)
mainRoutes = mainRoutes.concat(invoiceRoutes)
mainRoutes = mainRoutes.concat(reconcileRoutes)
mainRoutes = mainRoutes.concat(walletRoutes)
mainRoutes = mainRoutes.concat(userRoutes)
mainRoutes = mainRoutes.concat(settingRoutes)
mainRoutes = mainRoutes.concat(languageRoutes)
mainRoutes = mainRoutes.concat(adImageRoutes)
mainRoutes = mainRoutes.concat(MasjidImage)
mainRoutes = mainRoutes.concat(activityRoutes)
mainRoutes = mainRoutes.concat(inventoryRoutes)
mainRoutes = mainRoutes.concat(numberSearch)
mainRoutes = mainRoutes.concat(taskRoutes)
mainRoutes = mainRoutes.concat(bonventaRoutes)
mainRoutes = mainRoutes.concat(marketingRoutes)


let routes = [
  {
    path: '/',
    name: 'main',
    component: Main,
    children: mainRoutes,
    redirect: { path: '/home' },
    beforeEnter: (to, from, next) => {
      if ((localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`) == null)) {
        console.log('No token was found') // eslint-disable-line
        next({
          path: '/login',
          params: { nextUrl: to.fullPath },
        })
      } else {
        next()
      }
    },
  },
]

// Add login routes to the app.
routes = routes.concat(MasjidAd)
routes = routes.concat(loginRoutes)
routes = routes.concat(signUpRoutes)
routes = routes.concat(newOrganizationRoutes)
routes = routes.concat(globalRoutes)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  },
})

router.beforeEach((to, from, next) => {
  document.title = 'CRM'
  next()
})

export default router
